const MULTIPLIER = 6;

export const creditsBankMaxCounter = (credits: number): number => credits * MULTIPLIER;
